import { Component, Host, h, Prop, Listen, Event, EventEmitter } from '@stencil/core';
import Debounce from 'debounce-decorator'
import { TooltipEvent } from './TooltipEvent';


@Component({
  tag: 'lilu-tooltip',
  styleUrl: 'lilu-tooltip.scss',
  shadow: true,
})
export class LiluTooltip {

  @Prop() content = '';
  @Prop() open = false;
  @Prop() closeText = false;

  tooltipOverlay!: HTMLInputElement;
  clickPrevent = false;

  @Event()
  linkIsOpen: EventEmitter<TooltipEvent>;

  @Listen('linkIsOpen', { target: 'window' })
  closeAllInstances() {
    this.hide();
  }

  @Listen('resize', { target: 'window' })
  @Debounce(1000)
  onResize() {
    this.hide()
  }

  clickHandler = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    if (evt.target.className.includes('lilu-tooltip-content-inner')) {
      evt.preventDefault();
    } else {
      if(!this.open){
        this.show();
      } else {
        this.hide();
      }
    }
  };

  show = (evt?) => {
    if(evt)  evt.stopPropagation();

    // hide others
    this.linkIsOpen.emit({ isOpen: true });

    //show tooltip
    this.tooltipOverlay.classList.add('lilu-tooltip-content-visible');
    this.tooltipOverlay.style.display = 'block';
    this.open = true;

    // calc position
    let width = this.tooltipOverlay.clientWidth;
    let box = this.tooltipOverlay.getBoundingClientRect();
    let iconHeight = this.getHeight = this.getWidth(this.tooltipOverlay.parentNode);
    this.tooltipOverlay.style.bottom = `${iconHeight + 11}px`;

    if(box.left < 0){
      // too far left
      this.tooltipOverlay.classList.add('lilu-tooltip-content-right');
    }
    if(box.top < 0){
      // too far top
      this.tooltipOverlay.classList.add('lilu-tooltip-content-bottom');
      this.tooltipOverlay.style.bottom = '-4px';
    }

    // too far right
    if(box.left + width > window.innerWidth){
      this.tooltipOverlay.style.left =  'auto';
      this.tooltipOverlay.classList.add('lilu-tooltip-content-left');
    }
    this.tooltipOverlay.style.opacity = '1';

  }

  getWidth = (elem) => {
    const wrapperComputedStyle = window.getComputedStyle(elem, null)
    let wrapperWidth = elem.clientWidth
    wrapperWidth -=
      parseFloat(wrapperComputedStyle.paddingLeft) +
      parseFloat(wrapperComputedStyle.paddingRight)
      return wrapperWidth;
  }

  getHeight = (elem) => {
    const wrapperComputedStyle = window.getComputedStyle(elem, null)
    let wrapperWidth = elem.clientHeight
    wrapperWidth -=
      parseFloat(wrapperComputedStyle.paddingTop) +
      parseFloat(wrapperComputedStyle.paddingBottom)
      return wrapperWidth;
  }

  hide = () => {
    this.open = false;
    this.tooltipOverlay.classList.remove('lilu-tooltip-content-visible');
    this.tooltipOverlay.style.display = 'none';
    this.tooltipOverlay.classList.remove('lilu-tooltip-content-right');
    this.tooltipOverlay.classList.remove('lilu-tooltip-content-left');
    this.tooltipOverlay.classList.remove('lilu-tooltip-content-bottom');
    this.tooltipOverlay.style.bottom = '';
    this.tooltipOverlay.style.opacity = '0';
  }

  @Listen('click', { target: 'window' })
  handleAllClicks(evt) {
    let target = evt.target;
    if(this.open && ((target && target.nodeName.toLowerCase() !== 'lilu-tooltip') || !target)){
      this.hide();
    }
  }

  render() {
    return (
      <Host>
        <a class={`lilu-tooltip-trigger ${this.open ? 'open' : ''}`} onClick={(evt) => this.clickHandler(evt)}>
          <div class="lilu-tooltip-content" ref={(el) => this.tooltipOverlay = el as HTMLInputElement}>
            <div class="lilu-tooltip-content-inner" innerHTML={this.content}></div>
            <button class="lilu-tooltip-content-close">
              <lilu-icon size='lg-size' color='nero' type='icon-closed-01'></lilu-icon>
            </button>
          </div>
          <slot name="icon"></slot>
        </a>
      </Host>
    );
  }

}
